import { Button, cn } from '@scatterlab/zeta-core';
import {
  ComponentPropsWithoutRef,
  ComponentRef,
  ComponentType,
  createElement,
  ElementType,
  memo,
  RefAttributes,
  SVGProps,
} from 'react';

export type IconButtonProps<Component extends ElementType = typeof Button> =
  ComponentPropsWithoutRef<Component> &
    RefAttributes<ComponentRef<Component>> & {
      icon: ComponentType<SVGProps<SVGSVGElement>>;
      component?: Component;
      iconClassName?: string;
    };

const IconButton = <Component extends ElementType = typeof Button>({
  className,
  icon,
  component,
  iconClassName,
  children,
  ...props
}: IconButtonProps<Component>) =>
  createElement(
    component ?? Button,
    {
      className: cn(
        'flex h-fit shrink-0 flex-row items-center justify-center p-1 transition-colors disabled:cursor-not-allowed disabled:text-white/50',
        className,
      ),
      ...props,
    },
    <>
      {children}
      {createElement(icon, {
        className: cn('size-6 text-white', iconClassName),
      })}
    </>,
  );

export default memo(IconButton) as typeof IconButton;
